/* eslint-disable react/button-has-type */
/* eslint-disable @typescript-eslint/no-var-requires */
import React from 'react';

import './component004.less';
interface IComponents004Props {
  img: string;
  img1: string;
  className?: string;
}

const Components004: React.FunctionComponent<IComponents004Props> = ({
  img,
  img1,
  className,
}) => (
  <>
    <div className={`RealCase Desktop ${className}`}>
      <img src={require(`../../../../../assets/${img}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/965152/%E5%81%87%E6%9D%B1%E7%80%9B%E9%81%8Afb%E5%B0%88%E9%A0%81%E6%9C%8910%E8%90%AC%E7%B6%B2%E6%B0%91%E8%BF%BD%E8%B9%A4-%E6%96%B9%E4%BF%9D%E5%83%91%E5%AF%A6%E6%B8%AC%E6%8F%AD%E9%A8%99%E5%BE%92%E6%AE%B7%E5%8B%A4%E5%82%AC%E4%BF%83%E8%A8%82%E6%A9%9F%E7%A5%A8'
          );
        }}
        className="source1"
      />
    </div>
    <div className={`RealCase Moblie ${className}`}>
      <img src={require(`../../../../../assets/${img1}`).default} alt="" />
      <button
        onClick={() => {
          window.open(
            'https://www.hk01.com/%E7%A4%BE%E6%9C%83%E6%96%B0%E8%81%9E/965152/%E5%81%87%E6%9D%B1%E7%80%9B%E9%81%8Afb%E5%B0%88%E9%A0%81%E6%9C%8910%E8%90%AC%E7%B6%B2%E6%B0%91%E8%BF%BD%E8%B9%A4-%E6%96%B9%E4%BF%9D%E5%83%91%E5%AF%A6%E6%B8%AC%E6%8F%AD%E9%A8%99%E5%BE%92%E6%AE%B7%E5%8B%A4%E5%82%AC%E4%BF%83%E8%A8%82%E6%A9%9F%E7%A5%A8'
          );
        }}
        className="source1"
      />
    </div>
  </>
);

export default Components004;
